import {Icon, IconProps} from '@chakra-ui/react';

export const ChevronIcon = (props: IconProps) => (
  <Icon width="12px" height="8px" viewBox="0 0 12 8" fill="none" transition="transform 0.3s" {...props}>
    <path
      d="M1 6.5L6 1.5L11 6.5"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);
